import React, { Fragment, useEffect, useState } from 'react';

import Block from '../../../Scafolding/Block';
import { TextHeader, TextTitle } from '../../../Digital/TextHeaders';


import { Container, Row, Col, Table, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { SSDComps } from '../../../../Brands/SSD/Start';
import CompsAPI from '../Shared/DataCompAPI';
import Common from '../../../../Shared/Common';

export const Comps_ClubCompsResults = (props) => {
    return (
        <SSDComps>
            <Comps_ClubCompsResultsContent />
        </SSDComps>
    );
}   
export default Comps_ClubCompsResults;

export const Comps_ClubCompsResultsContent = (props) => {

    const [initalLoad, setInitialLoad] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const [results, setResults] = useState([]);
    const [filteredDataNew, setFilteredDataNew] = useState(results);
    const [filteredDataOld, setFilteredDataOld] = useState(results);

    useEffect(() => {
        CompsAPI.getCompResult({}, getResultsBack);
    }, []);

    let getResultsBack = (data) => {
        setResults(data);

        const resultsOld = data.filter(item => {
            if (item.modern) {
                return true;
            }
        }
        );
        setFilteredDataOld(resultsOld);

        const resultsNew = data.filter(item => {
            if (!item.modern) {
                return true;
            }
        }
        );
        setFilteredDataNew(resultsNew);
    };

    let reset = () => { setSearchTerm(''); };

    return (
        <Block name="Records" isAlt={false}>

            <TextHeader
                text={"Club Results - Early Years"}
            />

            <Row>
                <Col>
                    <Table striped hover borderless>
                        <thead>
                            <tr>
                                <th colspan="2">
                                    Result
                                </th>
                                <th>
                                    Diver
                                </th>
                                <th>
                                    Date
                                </th>
                                <th>
                                    Location
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredDataOld.map((entry, entryIndex) =>
                                <tr key={entryIndex}>
                                    <td>
                                        <span>{entry.resultName}</span>
                                    </td>
                                    <td>
                                        <span>{entry.result}</span>
                                    </td>
                                    <td>
                                        <span>{entry.diver}</span>
                                    </td>
                                    <td>
                                        <span>{entry.catchdate}</span>
                                    </td>
                                    <td>
                                        <span>{entry.location}</span>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>

            <TextHeader
                text={"Club Results - Modern Era (post restricted score sheet)"}
            />

            <Row>
                <Col>
                    <Table striped hover borderless>
                        <thead>
                            <tr>
                                <th colspan="2">
                                    Result
                                </th>
                                <th>
                                    Diver
                                </th>
                                <th>
                                    Date
                                </th>
                                <th>
                                    Location
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredDataNew.map((entry, entryIndex) =>
                                <tr key={entryIndex}>
                                    <td>
                                        <span>{entry.resultName}</span>
                                    </td>
                                    <td>
                                        <span>{entry.result}</span>
                                    </td>
                                    <td>
                                        <span>{entry.diver}</span>
                                    </td>
                                    <td>
                                        <span>{entry.catchdate}</span>
                                    </td>
                                    <td>
                                        <span>{entry.location}</span>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>

        </Block>
    );
}
